module.exports = __webpack_public_path__ + "img/xztk.ac60764b.png";